<template>
  <div class="card">
    <div>
      <p class="font-semibold text-deepBlue font-lg">Engagement Settings</p>
    </div>
    <div>
      <p class="font-semibold text-deepBlue font-lg">Account Management</p>
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-4 col-lg-12">
            <div class="flex items-center">
              <div class="w-full md:w-1/3">
                <p class="text-sm py-4">Assign Customer To:</p>
                <el-select
                  v-model="selectedAccountManagers"
                  multiple
                  placeholder="Select"
                >
                  <el-option
                    v-for="manager in accountManagers"
                    :key="manager.id"
                    :label="manager.name"
                    :value="manager.id"
                  >
                  </el-option>
                </el-select>

                <div
                  class="flex items-center cursor-pointer py-4"
                  @click="isAccountManagerForm = true"
                >
                  <span
                    ><svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.9998 0C5.37259 0 0 5.37267 0 11.9999C0 18.6269 5.37251 24 11.9996 24C18.6268 24 23.9998 18.6269 23.9998 11.9999C23.9998 5.37267 18.6269 0 11.9998 0ZM17.0622 13.3199H13.2007V17.3574C13.2004 18.0345 12.6516 18.5833 11.9744 18.5833C11.297 18.5833 10.7482 18.0345 10.7482 17.357V13.3199H6.98945C6.31218 13.3197 5.76362 12.7709 5.76322 12.0937C5.76322 11.4167 6.31226 10.8677 6.98945 10.8675L10.7481 10.8677V7.28449C10.7481 6.60721 11.2972 6.05826 11.9742 6.05826C12.6516 6.05826 13.2007 6.60729 13.2004 7.28449L13.2007 10.8674L17.0618 10.8678C17.7391 10.8674 18.2883 11.4166 18.2881 12.094C18.2883 12.7713 17.7391 13.3199 17.0622 13.3199Z"
                        fill="#E59506"
                      />
                    </svg>
                  </span>
                  <span class="pl-2 font-semibold cursor-pointer text-gold"
                    >Add New</span
                  >
                </div>
              </div>

              <span
                class="pl-2 font-semibold cursor-pointer text-gold"
                @click="updateContactAccountManagers"
                >Save Changes</span
              >
            </div>
          </div>
          <!-- <div class="col-12 col-md-4 col-lg-6">

          </div> -->
        </div>
      </div>
    </div>
    <hr />
    <div class="backlist my-6">
      <p class="font-semibold text-deepBlue font-lg pb-4">Blacklist:</p>
      <div class="flex">
        <!-- {{ blacklistPayload.isSuspended }} -->
        <base-checkbox v-model="blacklistPayload.isSuspended" />
        <p class="text-sm pl-2">Blacklist this Supplier</p>
        <div class="flex items-center">
          <div class="flex">
            <label class="label text-sm mx-4  ">Reason for Blacklist:</label>
            <input
              type="text"
              class="input mb-0"
              v-model="blacklistPayload.suspendReason"
            />
          </div>
          <span
            class="pl-2 font-semibold cursor-pointer text-gold"
            @click="blacklistContact"
            >Save Changes</span
          >
        </div>
      </div>
    </div>
    <div class="location my-6">
      <p class="font-semibold text-deepBlue font-lg pb-4">
        Delivery Locations:
      </p>
      <div class="flex pb-6">
        <div
          class="flex items-center"
          v-for="(address, index) in contact.deliveryAddress"
          :key="index"
        >
          <base-checkbox :id="`address${index}`" v-model="selectLocation" :value="`${address.location}`"/>
          <p class="text-sm pl-4" :for="`address${index}`">
            {{ address.location }} 
          </p>
        </div>
        <span class="pl-12 font-semibold cursor-pointer text-gold"
         @click="updateLocation" >Save Changes</span
        >
      </div>
      <small v-if='show' class="underline cursor-pointer">Set as Default</small>
    </div>

    <account-manager-form
      :show-modal="isAccountManagerForm"
      @close-modal="isAccountManagerForm = false"
      @account-manager-created="getAccountManagers"
    />
  </div>
</template>

<script>
import AccountManagerForm from "../Modals/AccountManagerForm";
export default {
  name: "settings",
  components: {
    AccountManagerForm,
  },
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      accountManagers: [],
      selectedAccountManagers: [],
      selectLocation: [],
      selectedLocation: null,
      isAccountManagerForm: false,
      loading: false,
      blacklistPayload: {
        contactId: this.contact.id,
        isSuspended: false,
        suspendReason: "",
      },
    };
  },
  watch: {
    "selectLocation" (val) {
      this.selectedLocation = val
    },
    "contact.accountManager"() {
      this.saveManagerIds();
    },
  },
  mounted() {
    this.getAccountManagers();
    this.saveManagerIds();
  },
  methods: {
    async updateContactAccountManagers() {
      let updatedManagers = this.accountManagers.filter((manager) => {
        return this.selectedAccountManagers.includes(manager.id);
      });
      this.loading = true;
      this.generateToast("Updating!", "success");
      let orgId = localStorage.getItem("organizationId");
      const payload = {
        userInfo: {
          orgId: orgId,
          outletId: null,
          creatorId: orgId,
        },
        payload: {
          accountManager: updatedManagers,
        },
      };
      try {
        const response = await this.$_updateContact(this.contact.id, payload);
        console.log(response, payload);
        this.logResponse(response);
        this.generateToast("Account manager updated successfully!", "success");
        this.$emit("contact-updated");
        // this.saveManagerIds();
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    async updateLocation () {
      const newLocation = this.selectedLocation
      this.loading = true;
      this.generateToast("Updating!", "success");
      let orgId = localStorage.getItem("organizationId");
      const payload = {
        location: newLocation,
        orgId: orgId
      }
      if(newLocation != null && newLocation != []) {
        try {
        const response = await this.$_updateContact(this.contact.id, payload)
        this.logResponse(response);
        this.generateToast("Location updated successfully!", "success");
        this.$emit("location-updated")
      } catch (e) {
        this.handleError(e)
      } 
      } else {
        this.generateToast("Please Select a location", "error");
      }
      this.selectLocation = null
      this.selectLocation = []
      this.loading =false
    },
    saveManagerIds() {
      this.selectedAccountManagers = [];
      if (this.contact.accountManager.length) {
        this.contact.accountManager.forEach((manager) => {
          this.selectedAccountManagers.push(manager.id);
        });
      }
    },
    async blacklistContact() {
      this.generateToast("Blacklisting contact!", "success");
      this.loading = true;
      try {
        const response = await this.$_blacklistContact(this.blacklistPayload);
        this.logResponse(response);
        this.generateToast(`${response.data.message}`, "success");
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    async getAccountManagers() {
      try {
        const response = await this.$_getAccountManagers();
        this.logResponse(response);
        this.accountManagers = response.data.accountManagers;
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style scoped>
td {
  padding: 0.25rem 0.5rem;
}
</style>
